import ko from "knockout";
import metaCache from "flow/utils/metaCache";
import { LoadingStatus } from "./splashStore";
import * as splashStore from "./splashStore";

export default class SplashScreen {
    ariaLabel = metaCache.translate("FlowHtml.Translations.ApplicationLogo");
    showList = ko.observable(false);

    isVisible = splashStore.isVisible;
    progress = splashStore.progress;
    statusText = splashStore.statusText;
    tasks = splashStore.tasks;
    disableTransition = splashStore.disableTransition;
    totalCount = splashStore.totalCount;

    toggleList() {
        this.showList(!this.showList());
    }

    getStatusIcon(status: LoadingStatus) {
        switch (status) {
            case LoadingStatus.Loading:
                return "lc-icon-Time";
            case LoadingStatus.Success:
                return "lc-icon-Check-mark";
            case LoadingStatus.Error:
                return "lc-icon-Alert";
            default:
                throw new Error("Unknown loading status state: " + status);
        }
    }

    isWaiting(status: LoadingStatus) {
        return status === LoadingStatus.Loading;
    }
}
